import React, { FC } from 'react';
import ProfileLinkWithAvatar from './ProfileLinkWithAvatar';
import { getInitials } from 'helpers/common';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { makeEmployeeLabel } from 'utils/employee.utils';

interface IEmployeeLinkWithAvatar {
  employee: IEmployeeBasicInfo;
  path?: string;
  titleClass?: string;
  avatarClass?: string;
  pathSecondPart?: string;
  size?: number;
  onClick?: () => void;
}

const EmployeeLinkWithAvatar: FC<IEmployeeLinkWithAvatar> = ({
  employee,
  path = '/employees',
  pathSecondPart = '',
  titleClass,
  avatarClass,
  size,
  onClick,
}) => {
  const titleSplit = employee.title?.split(' ');
  const initials = getInitials(
    titleSplit?.length ? titleSplit[0] : employee.firstName,
    titleSplit?.length ? titleSplit[1] : employee.lastName,
  );

  return (
    <ProfileLinkWithAvatar
      label={makeEmployeeLabel(employee)}
      link={`${path}/${employee.id}${pathSecondPart}`}
      initials={initials}
      titleClass={titleClass}
      avatarClass={avatarClass}
      imageUrl={employee.imageUrl}
      size={size}
      onClick={onClick}
    />
  );
};

export default EmployeeLinkWithAvatar;
